import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons';

const SpeechInputComponent = ({ label, name, value, onChange, placeholder, maxLength }) => {
  // const handleMicrophoneClick = () => {
  //   if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
  //     const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  //     const recognition = new SpeechRecognition();

  //     recognition.lang = 'en-US';
  //     recognition.interimResults = false;
  //     recognition.maxAlternatives = 1;

  //     recognition.onstart = () => {
  //       console.log("Speech recognition started");
  //     };

  //     recognition.onresult = (event) => {
  //       const speechResult = event.results[0][0].transcript;
  //       console.log("Speech result:", speechResult); 
  //       onChange({
  //         target: {
  //           name,
  //           value: value + ' ' + speechResult,
  //         },
  //       });
  //     };

  //     recognition.onerror = (event) => {
  //       console.error('Speech recognition error:', event.error);
  //       alert(`Speech recognition error: ${event.error}`);
  //   };

  //     recognition.onend = () => {
  //       console.log("Speech recognition ended");
  //     };

  //     recognition.start();
  //   } else {
  //     alert('Speech recognition is not supported in this browser. Please use Google Chrome.');
  //   }
  // };

  const handleMicrophoneClick = async () => {
    try {
      // Ask browser microphone permission first
      await navigator.mediaDevices.getUserMedia({ audio: true });
      const SpeechRecognition =
        window.SpeechRecognition ||
        window.webkitSpeechRecognition;

      if (!SpeechRecognition) {
        alert(
          "Speech Recognition not supported. Please use Google Chrome."
        );
        return;
      }
      const recognition = new SpeechRecognition();
      recognition.lang = "en-IN";
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;
      recognition.onstart = () => {
        // console.log("Speech recognition started");
      };

      recognition.onresult = (event) => {
        const speechResult = event.results[0][0].transcript;
        // console.log("Speech result:", speechResult);
        onChange({
          target: {
            name,
            value: value
              ? value + " " + speechResult
              : speechResult,
          },
        });
      };

      recognition.onerror = (event) => {
        console.error(
          "Speech recognition error:",
          event.error
        );
        if (event.error === "not-allowed") {
          alert(
            "Microphone permission denied. Please allow microphone access in browser settings."
          );

        } else {
          alert(
            `Speech recognition error: ${event.error}`
          );
        }
      };
      recognition.onend = () => {
        // console.log("Speech recognition ended");
      };
      recognition.start();
    } catch (err) {
      console.error(err);
      alert("Microphone access blocked. Please allow microphone permission.");
    }
  };

  return (
    <div className="text-sm px-4 py-2">
      {/* <label htmlFor={name}>{label}</label> */}
      <button
        className="p-2 bg-green-500 text-white w-auto rounded-lg flex items-center hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300 transition duration-150 ease-in-out whitespace-nowrap"
        onClick={handleMicrophoneClick}
        aria-label="Start speech recognition"
        >
        <FontAwesomeIcon icon={faMicrophone} className="mr-2" style={{ color: 'white' }} />
        <span>Speak {label}</span>
      </button>
      <textarea
        type={name}
        name={name}
        id={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        maxLength={maxLength}
        style={{
          border: '1px solid #ccc',
          padding: '2px',
          backgroundColor: '#f0f0f0',
          color: '#000000',
          maxWidth: '100%',
          maxHeight: '150px',
        }}
      />
    </div>
  );
};

export default SpeechInputComponent;
